import { theme, Grid, Hamburger } from '@zappyrent/hundop';
import { useState } from 'react';
import Media from 'react-media';

import Logo from '../../Logo';
import NavMenu from '../../NavMenu';
import { StyledHeader, StyledMobileNavMenuWrapper } from './Header.styles';

const Header = (): JSX.Element => {
  const [isMobileNavigationVisible, setIsMobileNavigationVisible] =
    useState(false);

  const handleHamburgerClick = () => {
    setIsMobileNavigationVisible(
      prevIsMobileNavigationVisible => !prevIsMobileNavigationVisible,
    );
  };

  return (
    <Media
      queries={{
        mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
        desktop: `(min-width: ${theme.breakpoints.l})`,
      }}
    >
      {matches => (
        <>
          {matches.desktop && (
            <StyledHeader>
              <Logo />
              <NavMenu />
            </StyledHeader>
          )}
          {matches.mobile && (
            <StyledHeader>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Logo />
                <Hamburger onClick={handleHamburgerClick} />
                {isMobileNavigationVisible && (
                  <StyledMobileNavMenuWrapper>
                    <Grid container>
                      <NavMenu />
                    </Grid>
                  </StyledMobileNavMenuWrapper>
                )}
              </Grid>
            </StyledHeader>
          )}
        </>
      )}
    </Media>
  );
};

export default Header;
